import * as views from './pages'

angular.module('app.financeiro').config(function ($stateProvider, lazyLoadProvider) {
    $stateProvider
        .state('app.financeiro', {
            abstract: true
        })
        .state('app.financeiro.bos', {
            abstract: true
        })
        .state('app.financeiro.bos.situacaoPagamentoAutomatico', {
            url: '/bos/situacaoPagamentoAutomatico',
            views: {
                'content@app': lazyLoadProvider.create(views.bos.situacaoPagamentoAutomatico)
            },
            data: {
                title: 'Situação Pagamento Automático',
                access: { requiredPermissions: ['RemessaPagamento', 'backoffice'] },
                breadcrumbs: ['BOS', 'Situação Pagamento Automático']
            }
        })
        .state('app.financeiro.bos.tempoDesembolso', {
            url: '/bos/tempoDesembolso',
            views: {
                'content@app': lazyLoadProvider.create(views.bos.tempoDesembolso)
            },
            data: {
                title: 'Tempo de Desembolso',
                access: { requiredPermissions: ['RemessaPagamento', 'backoffice'] },
                breadcrumbs: ['BOS', 'Tempo de Desembolso']
            }
        })
});